import React, { useState } from "react";
import { Link } from "react-router-dom";
import { API_URL, TENANT_ID } from "../../config";
import AuthScreenLayout from "../../components/AuthScreenLayout";
import "./ForgotPassword.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    // Basic email validation
    const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRe.test(email)) {
      setError("Por favor, introduce un correo electrónico válido.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-tenant-id": TENANT_ID,
        },
        body: JSON.stringify({ email }),
      });

      // Verificar si la respuesta es JSON antes de parsear
      const contentType = response.headers.get("content-type");
      let data;
      
      if (contentType && contentType.includes("application/json")) {
        try {
          data = await response.json();
        } catch (jsonError) {
          console.error("Error al parsear JSON:", jsonError);
          setError("El servidor devolvió una respuesta inválida. Intenta nuevamente.");
          return;
        }
      } else {
                if (response.status === 429) {
                  setError("Demasiados intentos. Por favor, inténtalo más tarde.");
                  return;
                }
                // Si no es JSON, intentar leer como texto para debugging
                const text = await response.text();
                console.error("Respuesta no JSON del servidor:", text);
                setError("Error del servidor. Por favor, contacta al administrador.");
                return;
              }

      if (response.ok) {
        setMessage(data.mensaje);
        setEmail(""); // Clear input
      } else {
        if (response.status === 429) {
             setError("Demasiados intentos. Por favor, inténtalo más tarde.");
        } else {
             setError(data.error || "Ocurrió un error. Intenta nuevamente.");
        }
      }
    } catch (err) {
      console.error("Error en la solicitud:", err);
      
      // Distinguir entre diferentes tipos de errores
      if (err instanceof TypeError) {
        // Error de red real (sin conexión, servidor no disponible, CORS)
        setError("Error de conexión. Verifica tu internet e intenta nuevamente.");
      } else if (err.name === "AbortError") {
        // Timeout o solicitud cancelada
        setError("La solicitud tardó demasiado. Intenta nuevamente.");
      } else {
        // Otro tipo de error
        setError("Ocurrió un error inesperado. Intenta nuevamente.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthScreenLayout>
      <div className="forgot-password-card">
        <h2>Recuperar Contraseña</h2>
        <p>Introduce tu correo electrónico para recibir un enlace de restablecimiento.</p>

        {message && <div className="forgot-password-message success">{message}</div>}
        {error && <div className="forgot-password-message error">{error}</div>}

        <form onSubmit={handleSubmit} className="forgot-password-form">
          <input
            type="email"
            className="forgot-password-input"
            placeholder="Correo electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />
          <button type="submit" className="forgot-password-button" disabled={loading}>
            {loading ? "Enviando..." : "Enviar enlace"}
          </button>
        </form>

        <Link to="/login" className="back-to-login">
          ← Volver al inicio de sesión
        </Link>
      </div>
    </AuthScreenLayout>
  );
};

export default ForgotPassword;
